import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { Sidebar } from './Sidebar';

export function Shell() {
  const location = useLocation();
  const isLogin = location.pathname.endsWith('/login');
  const isOnboarding = location.pathname.endsWith('/onboarding');

  if (isLogin || isOnboarding) {
    return <Outlet />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex">
        {/* Desktop sidebar */}
        <aside className="hidden lg:block w-64 flex-shrink-0" aria-label="Menú lateral">
          <Sidebar />
        </aside>

        {/* Main content */}
        <main className="flex-1 pb-20 lg:pb-6 pt-16" aria-label="Contenido principal">
          <div className="max-w-4xl mx-auto px-4 py-6">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Mobile bottom nav */}
      <BottomNav />
    </div>
  );
}
